import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditTemplateBasicFormComponent } from '../discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { ChangeDetectorRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';

import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { DocumentService, UserService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { AddTrustTemplate } from '../add-trust-template-dialog/add-trust-template.interfaces';
import { AskSecurityKeyPasswordComponent } from '@app/modules/vault/components/dialogs/ask-security-key-password/ask-security-key-password.component';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { loaderTypes } from '../loader/loader';
import { ToastrService } from 'ngx-toastr';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'create-from-with-vault',
  templateUrl: './create-from-with-vault.component.html',
  styleUrl: './create-from-with-vault.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateFromWithVaultComponent implements OnInit, OnDestroy {
  current_template;
  forms = [];
  visibility = false;
  savingForm = false;
  isDocumentLinking = true;
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  formData = [];
  beneFicaryForm = [];
  Form1;
  security_key;
  manageSecuritykey;
  sk;
  formEncryptionKey;
  form_name_updated_by_user = true;
  vault_user_form_id;
  subscription = new Subscription();
  documentForm: UntypedFormGroup;
  securityStateObject;
  firstStepDisable = false;
  CurrentStep = 1;
  entityName;

  is_secure = false;
  loadingItems = [{ id: 1 }, { id: 2 }];
  vault_id;
  vault_list = [];
  editName = '';
  searchTextType = '';
  selected_vault;
  showDropDown = false;
  currentUserData;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddTrustTemplate,
    public dialogRef: MatDialogRef<CreateFromWithVaultComponent>,
    private vaultService: VaultStoreEffects,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private cryptoService: CryptoService,
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginStoreEffects,
    private userService: UserService,
    private toastr: ToastrService
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  selectFormForTypeTask(item) {
    this.selected_vault = item;
    this.searchTextType = '';
    this.showDropDown = false;
    this.createformIdForFirstUploadDocument();
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentUserData = state.data;
        }
      })
    );

    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
        this.vault_list = state.vaults;
      })
    );
    this.isDocumentLinking = this.data?.isDocumentLinking ?? true;
    this.form_name_updated_by_user = this.data?.form_name_updated_by_user ?? true;
    this.initData();
  }

  initData() {
    if (this.data.origin !== 'MxFinancialAccount') {
      this.current_template = this.forms.find((x) => x.id == this.data?.vaultFormId);
      if (this.current_template.template[0].singleFieldForm.findIndex((x) => x.record_default) == -1) {
        this.firstStepDisable = true;
      }
      this.formData = this.current_template.template;
      this.documentForm = this.formBuilder.group({
        documentType: ['', Validators.required],
        documentName: ['', Validators.required],
        status_progress: ['need to add', Validators.required],
        formSelection: ['', Validators.required],
        selectSaveFolder: ['', Validators.required],
        selectOfficeSaveFolder: ['', Validators.required],
        dynamicFieldsForm: new UntypedFormArray([]),
        beneFicaryForm: new UntypedFormArray([]),
        attributeFormsList: new UntypedFormArray([]),
        showNotes: [''],
        physicalLocation: [''],
        notes: [''],
        expiration_date: [''],
        expiration_notification: [''],
        review_date: [''],
        review_notification: [''],
        renewal_notification: [''],
        renewal_date: [''],
        recurring_expiration: [''],
        value_currency: ['USD'],
        value_current_currency: [''],
        value_is_appraisal: [''],
        value_appraisal_date: [''],
      });
    } else {
      this.CurrentStep = 2;
    }

    if (this.data.vault_id) {
      this.selected_vault = {
        id: this.data.vault_id,
      };
      this.searchTextType = '';
      this.showDropDown = false;
      this.createformIdForFirstUploadDocument();
      this.cd.detectChanges();
    }
    if (this.data.organization_section == 'Contacts' || this.data.organization_section == 'Accounts & Credentials') {
      this.visibility = false;
      this.createformIdForFirstUploadDocument();
    } else {
      this.visibility = true;
    }
  }

  loadDatawithTamplet(res) {
    const form_data = JSON.parse(res['vaultFormData'][0]['form_data']);
    this.Form1 = JSON.parse(res['vaultFormData'][0]['template']);
    this.formEncryptionKey = res['vaultFormData'][0]['encryption_key'];
    if (res['vaultFormData'][0]['security_key'] != null && res['vaultFormData'][0]['security_key'] != undefined) {
      this.is_secure = true;
      this.openSecurityPopup(res);
    } else {
      this.documentForm.controls.dynamicFieldsForm.setValue([form_data.dynamicFieldsForm]);
      this.beneFicaryForm = form_data.beneFicaryForm;
    }
  }
  openSecurityPopup(res) {
    const modalRef2 = this.dialog.open(AskSecurityKeyPasswordComponent, {
      data: {
        currentuserId: this.currentUserData.id,
        currentValutUserId: this.currentUserData.id,
        vaultFormId: this.data.id,
        data: res['vaultFormData'][0],
      },
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      modalRef2.afterClosed().subscribe((result) => {
        if (result?.isVerify) {
          // //decrypt form data
          this.sk = result.sk;
          this.security_key = result.security_key;
          this.manageSecuritykey = [result.security_key];
          if (res['vaultFormData'][0]['form_data'] != null && res['vaultFormData'][0]['form_data'] != undefined) {
            res['vaultFormData'][0]['form_data'] = this.cryptoService.decryptData(
              JSON.parse(res['vaultFormData'][0]['form_data']),
              result.security_key,
              result.sk
            );
          }
          let form_data = res['vaultFormData'][0]['form_data'];
          form_data = JSON.parse(form_data);
          this.documentForm.controls.dynamicFieldsForm.setValue([form_data.dynamicFieldsForm]);
          this.beneFicaryForm = form_data.beneFicaryForm;
        } else {
        }
      })
    );
  }

  moveToNextStep() {
    this.updateFormTemplateData();
  }
  createformIdForFirstUploadDocument() {
    let data = {
      user_id: this.currentUserData.id,
      vault_form_id: this.data.vaultFormId,
      vaultId: this.selected_vault?.id,
    };
    this.savingForm = true;
    this.subscription.add(
      this.documentService.getforIdForFirstUploadDocument(data, loaderTypes.mainAnimation).subscribe(
        (res) => {
          try {
            this.vault_id = this.selected_vault?.id;
            if (res.vault_user_form_id.vault_user_form_id) {
              this.vault_user_form_id = res.vault_user_form_id.vault_user_form_id;
            }
            this.securityStateObject = res['vault_user_form_id'].public_key;
          } catch (error) {}

          if (res.vault_user_form_id.vault_user_form_id) {
            this.vault_user_form_id = res.vault_user_form_id.vault_user_form_id;
          }
          const payload = {
            id: this.vault_user_form_id,
            status_progress: 'need to add',
            user_id: this.currentUserData.id,
            form_data: {
              beneFicaryForm: [],
              dynamicFieldsForm: {},
              showNotes: undefined,
            },
            user_pk: this.securityStateObject.public_key,
          };
          this.savingForm = true;
          this.subscription.add(
            this.documentService.updateFormTampletData(payload, null, undefined, undefined, false, undefined, false).subscribe(
              (res) => {
                res.type = this.data.vaultType;
                this.dialogRef.close({
                  success: true,
                  ...res,
                });
              },
              (error) => {}
            )
          );
          if (this.isDocumentLinking) {
            this.formName();
          } else {
            this.saveFromName();
          }

          this.cd.detectChanges();
        },
        (error) => {}
      )
    );
  }
  saveFromName() {
    this.subscription.add(
      this.documentService
        .saveFormNameInDb({
          form_name: this.data?.displayType ? this.data?.displayType : this.data.title,
          id: this.vault_user_form_id,
          form_name_updated_by_user: this.form_name_updated_by_user,
        })
        .subscribe(
          (res) => {
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }
  updateFormTemplateData() {
    if (this.CurrentStep == 1) {
      this.CurrentStep = 2;
      this.cd.detectChanges();
      return;
    } else if (this.selected_vault == null || this.selected_vault == undefined || this.selected_vault == '') {
      return;
    } else if (!!this.data?.origin && this.data?.origin == 'MxFinancialAccount') {
      this.createUserMemberAccountSingle(this?.data?.selectedAccounts ?? []);
    } else {
      this.createformIdForFirstUploadDocument();
    }
    // if (this.is_secure) {
    //   this.subscription.add(
    //     this.documentService.getSecurityKeyWidhId(this.currentUserData.id).subscribe((res) => {
    //       if (res.Items != undefined && res.Items.length) {
    //         let request = {
    //           id: this.vault_user_form_id,
    //           status_progress: 'need to add',
    //           user_id: this.currentUserData.id,
    //           form_data: {
    //             beneFicaryForm: this.beneFicaryForm,
    //             dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
    //             showNotes: undefined,
    //           },
    //           security_key: '',
    //           user_pk: this.securityStateObject.public_key,
    //         };
    //         request['security_key'] = res.Items[0]['sk'];
    //         this.subscription.add(
    //           this.documentService
    //             .updateFormTampletData(request, res.Items[0], null, this.formEncryptionKey, false, this.sk, true)
    //             .subscribe((res) => {
    //               this.formName();
    //               res.type = this.data.vaultType;
    //               this.dialogRef.close(res);
    //             })
    //         );
    //       }
    //     })
    //   );
    // } else {

    // }
  }
  async createUserMemberAccountSingle(items: Array<Record<any, any>>) {
    const unlinkedAccountPayloads = items
      .filter((acct) => !acct.vaultUserForm)
      .map((item) => {
        return {
          user_id: this.currentUserData.id,
          user_account_guid: item.guid,
          vault_id: this.selected_vault.id,
        };
      });

    const linkedAccountPayloads = items
      .filter((acct) => !!acct.vaultUserForm)
      .map((item) => {
        return {
          vault_id: this.selected_vault.id,
          id: [item?.vaultUserForm.id],
          vault_user_id: this?.selected_vault.user_id,
        };
      });

    try {
      const unlinkedAccountRes: any = unlinkedAccountPayloads.map(async (item) => {
        return new Promise((resolve, reject) => {
          this.subscription.add(
            this.userService.createUserMemberAccountSingle(item).subscribe((res) => {
              resolve(res);
            })
          );
        });
      });
      const linkedAccountRes: any = linkedAccountPayloads.map(async (item) => {
        return new Promise((resolve, reject) => {
          this.subscription.add(
            this.documentService.updateFormGroupId(item).subscribe((res) => {
              resolve(res);
            })
          );
        });
      });

      const data = await Promise.allSettled([...unlinkedAccountRes, ...linkedAccountRes]);

      if (data.every((res) => res.status == 'fulfilled' && (!res?.value?.status || res?.value?.status == 200))) {
        this.dialogRef.close({ status: true });
        this.toastr.success('Moved successfully.');
      } else {
        this.toastr.error('Some items failed.');
      }
    } catch (error) {
      this.toastr.error('An error occurred while processing the request.');
    }
  }

  formName() {
    this.subscription.add(
      this.documentService
        .saveNameWithAction(
          {
            form_name: this.data?.suggestion_new_form_name || this.data?.title || this.documentForm.controls.documentName.value,
            id: this.vault_user_form_id,
            naming_convention: this.current_template.naming_convention,
            dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
            user_id: this.currentUserData.id,
            current_template: this.current_template,
            filterArrayItems: this.editTemplateBasicForm?.filterArrayItems ? this.editTemplateBasicForm?.filterArrayItems : [],
            vault_id: this.vault_id,
            vault_list: this.vault_list,
          },
          true
        )
        .subscribe(
          (res) => {
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }
  closeDialog() {
    this.dialogRef.close();
  }

  selectAllContent($event) {
    $event.target.select();
  }

  disableWhiteSpaceOnFirstCharacter(event) {
    if (event.target.selectionStart == 0 && (event.keyCode == 32 || event.keyCode == 9)) {
      event.preventDefault();
    }
  }

  handleInput(event) {
    this.entityName = event.target.value;
  }
}
